import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { toast } from "react-toastify";
import {
  appAddToWishlist,
  appRemoveWishlist,
} from "../../services/WishlistService";
import { setOpenPoup } from "../../store/actions/popupActions";
import {addWishlistCount} from "../../store/actions/authActions";
// import useShowNotification from "../../hooks/useShowNotification";
import { useSnackbar } from 'react-simple-snackbar';
import { isMobile } from "react-device-detect";

function WishlistItem({ productId, isInWishlist, className="wishlist" ,saveProductsCb, updateWishlistProductStatuscb}) {
  const dispatch = useDispatch();
  const snackbar_options = {
    position: isMobile?'top-center' : '',
    style: {
      marginTop : isMobile?'45px' : ''
    }    
  }
  const [openSnackbar] = useSnackbar(snackbar_options);
  const [wishlistItem, setWishlistItem] = useState(false);

  const authState = useSelector((state) => state.auth);

  useEffect(() => {
    setWishlistItem(isInWishlist || false);
  }, [isInWishlist]);

  const addToWishlist = (productId) => {
    if (authState?.token && authState?.isAuthenticated && authState?.user) {
      appAddToWishlist(productId).then((res) => {
        res = JSON.parse(res?.data);
        if (res.status === "success") {
          setWishlistItem(true);
          // toast.success(res.message);
          openSnackbar(res.message);
          updateWishlistProductStatuscb(productId,wishlistItem);
          let loginUser = authState?.user;
          loginUser.wishlist_count = res?.wishlist_count;
          dispatch(addWishlistCount(loginUser));
        } else {
          // toast.error(res.message);
          openSnackbar(res.message);
        }
      });
    } else {
      //TODO: Open login modal
      dispatch(setOpenPoup("login"));
    }
  };

  const removeFromWishlist = (productId) => {
    if (authState?.token && authState?.isAuthenticated && authState?.user) {
      appRemoveWishlist(productId).then((res) => {
        res = JSON.parse(res?.data);
        if (res.status === "success") {
          setWishlistItem(false);
          // toast.success(res.message);
          openSnackbar(res.message);
          updateWishlistProductStatuscb(productId,wishlistItem);
          let loginUser = authState?.user;
          loginUser.wishlist_count = res?.wishlist_count;
          dispatch(addWishlistCount(loginUser));
        } else {
          // toast.error(res.message);
          openSnackbar(res.message);
        }
      });
    } else {
      //TODO: Open login modal
    }
  };

  return (
    <div className={className}>
      {wishlistItem === true ? (
        <a
          onClick={(e) => removeFromWishlist(productId)}
          href 
          className="btn-blank"
        >
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/icons/Wishlist-button-grey-filled.png`}
            className="img-fluid mx-auto d-block"
            alt=""
          />
        </a>
      ) : (
        <a
          onClick={(e) => addToWishlist(productId)}
          href 
          className="btn-blank"
        >
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/icons/Wishlist-button-grey.png`}
            className="img-fluid mx-auto d-block"
            alt=""
          />
        </a>
      )}
    </div>
  );
}

export default WishlistItem;
